export default "<button [class]=\"'rw-button ' + class\" [disabled]=\"disabled\" [type]=\"type\">\r\n  <ng-content></ng-content>\r\n</button>";